import isEmpty from '@/helpers/empty'

export interface Helpers {
  isEmpty: (value: unknown) => boolean
}

export default <Helpers>{
  isEmpty
}
